import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter form" }
const _hoisted_2 = {
  class: "item",
  "data-size": "big"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "item" }
const _hoisted_5 = ["data-accentcolor"]
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { for: "IsApproved" }
const _hoisted_8 = {
  class: "item",
  "data-cta": "multi"
}
const _hoisted_9 = { class: "cta" }
const _hoisted_10 = {
  key: 0,
  class: "cta"
}

import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetFilterBox',
  props: {
    accentColor: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const localizer = Localizer;

const searchTextFilter = computed(() => (<any>window).App.bag.SearchText);
const isApprovedFilter = computed(() => (<any>window).App.bag.IsApproved === "True" ? true : false);
const projectDetailUrl = computed(() => (<any>window).App.bag.ProjectDetailUrl);

const searchText = ref(searchTextFilter.value);
const isApproved = ref(isApprovedFilter.value);

onMounted(() => {
	let searchObj = JSON.parse(window.sessionStorage.getItem("AssetSearch"));

	if (route.query.searchText) {
		searchText.value = <string>route.query.searchText;
	} else if (searchObj?.searchText) {
		searchText.value = searchObj.searchText;
	}

	if (route.query.isApproved) {
		isApproved.value = route.query.isApproved === "true";
	} else if (searchObj?.isApproved) {
		isApproved.value = searchObj.isApproved;
	}
});

function resetSearch() {
	searchText.value = null;
	isApproved.value = false;

	setSearch();
}

function setSearch() {
	let filters = [],
		filterCount = 0,
		queryString = "";

	if (searchText.value) {
		filters.push("searchText=" + searchText.value);
		filterCount++;
	}

	if (isApproved.value) {
		filters.push("isApproved=" + isApproved.value);
		filterCount++;
	}

	if (filterCount !== 0) {
		queryString = filters.join("&");

		window.sessionStorage.setItem("AssetSearch", JSON.stringify({ searchText: searchText.value, isApproved: isApproved.value }));

		window.location.href = projectDetailUrl.value + "?" + queryString;
	} else {
		window.sessionStorage.removeItem("AssetSearch");
		window.location.href = projectDetailUrl.value;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "textbox",
        type: "text",
        placeholder: _unref(localizer).get('PrivateArea.Common.ProjectDetail_FilterBox_SearchText_Placeholder'),
        onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (setSearch()), ["enter"])),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event))
      }, null, 40, _hoisted_3), [
        [_vModelText, searchText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "checkbox",
        "data-accentcolor": __props.accentColor ? true : false
      }, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "data-val": "true",
            id: "IsApproved",
            name: "IsApproved",
            value: "true",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isApproved).value = $event))
          }, null, 512), [
            [_vModelCheckbox, isApproved.value]
          ]),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_FilterBox_AssetApproved")), 1)
        ])
      ], 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setSearch())),
          "data-size": "small",
          style: _normalizeStyle([{'background-color': __props.accentColor}])
        }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_FilterBox_SearchButton")), 5)
      ]),
      (searchTextFilter.value !== '' || isApprovedFilter.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "button",
              "data-type": "link",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (resetSearch()))
            }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_FilterBox_ResetFilters")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})